import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	padding: 8em 0;

	.adblock-info {
		margin: 3em 0 4em 0;

        .adblock-title {
            color: ${vars.colorAlert};
			font-weight: 600;
			font-size: 1.1em;
			margin: 0 0 1em 0;
        }
    }

	.layout-container {
		background-color: #fff;
		padding-bottom: 3em;
	}

	.title {
		font-weight: 600;
		font-size: 2.3em;
		padding: 1.2em 0.1em;
		text-align: center;
		line-height: normal;
	}

	.cols {
		display: flex;
		align-items: flex-start;
		justify-content: center;

		.col-left {
			width: 50%;
			border-right: 1px solid #000000;
			padding: 1.2em 3em;

			.subtitle {
				font-weight: 600;
				font-size: 1.2em;
				margin-bottom: 1.4em;
			}

			.button-mobile-wrapper {
				display: none;
				align-items: center;
				justify-content: center;
			}

			.layout-button {
				margin-bottom: 1.4em;
				display: block;

				.button {
					background-color: #fff;

					.button-content {
						display: flex;
						align-items: center;
						justify-content: center;

						img {
							margin-right: 1em;
							max-height: 1.2em;
						}
					}
				}
			}

			.footer-wrapper {
				display: flex;
				align-items: center;
				justify-content: center;

				.footer {
					font-size: 1.2em;
					text-align: center;
				}

				.btn-login {
					font-weight: 600;
					text-decoration: underline;
					cursor: pointer;
					margin: 0;

					.button {
						padding: 0 0 0 0.4em;
					}
				}
			}
		}

		.col-right {
			width: 50%;
			padding-left: 2em;

			.description {
				background-color: #000000;
				color: #fff;
				font-size: 1.1em;
				padding: 1.4em;
				max-width: 25em;
				width: 40vw;
				margin: 0 auto;
				border-radius: 0.3em;
				text-align: left;
			}
		}
	}

	@media all and (max-width: ${vars.tabletS}) {
		padding: 8em 0 0;

		.layout-container {
			background: none;
		}

		.title {
			display: none;
		}

		.cols {
			flex-direction: column;

			.col-left {
				width: 100%;
				border-right: none;

				.subtitle {
					display: none;
				}

				.button-mobile-wrapper {
					display: block;

					.mobile-links {
						display: flex;
						justify-content: center;
						align-items: center;
						margin: 1em 0;

						.links {
							display: flex;
							min-width: 100%;

							.links-page {
								padding: 0.7em 2em;
								font-size: 1.1em;
								width: 50%;
								border-radius: 0.3em;
								color: ${vars.colorText};
								display: flex;
								justify-content: center;
								align-items: center;
								text-decoration: none;
							}
							.login-page {
								border: 0.09em solid ${vars.colorBorder};
							}
							.link-register {
								transform: translate(-2%);
								background-color: ${vars.colorElement};
								border: 0.09em solid ${vars.colorElement};
							}
						}
					}
				}

				.footer-wrapper {
					display: none;
				}
			}

			.col-right {
				width: 86%;
				padding: 0;
				margin: 0 auto;

				.description {
					max-width: 80vw;
					width: 100%;
				}
			}
		}
	}
	@media all and (max-width: ${vars.mobileM}) {
		padding: 0;

		.layout-container {
			width: 100%;
		}

		.cols {
			padding: 0;

			.col-left {
				padding-top: 0;
				margin-top: 0;

				.layout-button {
					.button {
						.button-content {
							font-size: 1em;
						}
					}
				}
			}
		}
	}
`;
